import { Typography, Paper } from '@mui/material'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'

const CheckRenaper = ({ renaperCheck }) => {
  const details = renaperCheck?.checkDetails?.renaperData
  const notFound = renaperCheck?.checkDetails?.found === false
  const hasErrorCode = details?.codigo === 3
  const hasData = !notFound && !hasErrorCode && details && Object.keys(details).length > 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>Renaper</Typography>
        <CheckRiskStatus checkLength={hasData ? 1 : 0} hasChecks={hasData} />
      </Paper>

      <CheckDetailTitle
        email={renaperCheck?.email}
        status={renaperCheck?.status}
        createdAt={renaperCheck?.createdAt}
        updatedAt={renaperCheck?.updatedAt}
      />

      {notFound && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">Información</Typography>
          <Typography variant="subtitle3">{renaperCheck?.checkDetails?.info || 'Información no disponible'}</Typography>
        </Paper>
      )}

      {hasErrorCode && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1" color="error">
            Error en los datos ingresados
          </Typography>
          <Typography variant="subtitle3">{details?.mensaje || 'Error desconocido en la consulta.'}</Typography>
        </Paper>
      )}

      {hasData && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">ID Trámite Principal</Typography>
                <Typography variant="subtitle3">{details?.id_tramite_principal || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">ID Tarjeta Reimpresa</Typography>
                <Typography variant="subtitle3">{details?.id_tramite_tarjeta_reimpresa || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Ejemplar</Typography>
                <Typography variant="subtitle3">{details?.ejemplar || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Vencimiento</Typography>
                <Typography variant="subtitle3">{details?.vencimiento || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Emisión</Typography>
                <Typography variant="subtitle3">{details?.emision || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">CUIL</Typography>
                <Typography variant="subtitle3">{details?.cuil || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Nombre</Typography>
                <Typography variant="subtitle3">{details?.nombres || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Apellido</Typography>
                <Typography variant="subtitle3">{details?.apellido || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Fecha de Nacimiento</Typography>
                <Typography variant="subtitle3">{details?.fecha_nacimiento || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Nacionalidad</Typography>
                <Typography variant="subtitle3">{details?.nacionalidad || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Calle</Typography>
                <Typography variant="subtitle3">{details?.calle || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Número</Typography>
                <Typography variant="subtitle3">{details?.numero || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Ciudad</Typography>
                <Typography variant="subtitle3">{details?.ciudad || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Provincia</Typography>
                <Typography variant="subtitle3">{details?.provincia || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">País</Typography>
                <Typography variant="subtitle3">{details?.pais || '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Mensaje del Renaper</Typography>
                <Typography variant="subtitle3">{details?.mensaje || '---'}</Typography>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}
    </>
  )
}

export default CheckRenaper

/* import { Box, Typography, Grid, Divider } from '@mui/material'
import CheckDetailTitle from './components/CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckRenaper = ({ title = '', renaperCheck, level = 0 }) => {
  const details = renaperCheck?.checkDetails?.renaperData

  if (renaperCheck?.checkDetails?.found === false) {
    return (
      <Box className="detail-group" sx={{ padding: '1.5rem' }}>
        <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1rem' }}>
          {title || 'Renaper'}
        </Typography>
        <CheckDetailTitle
          email={renaperCheck?.email}
          status={renaperCheck?.status}
          createdAt={renaperCheck?.createdAt}
          updatedAt={renaperCheck?.updatedAt}
        />
        <Typography variant="h4" sx={{ fontSize: '1rem', marginTop: '1rem' }}>
          No se encontraron datos.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1rem' }}>
          {renaperCheck?.checkDetails?.info || 'Información no disponible'}
        </Typography>
      </Box>
    )
  }

  if (details?.codigo === 3) {
    return (
      <Box className="detail-group" sx={{ padding: '1.5rem' }}>
        <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1rem' }}>
          {title || 'Renaper'}
        </Typography>
        <CheckDetailTitle
          email={renaperCheck?.email}
          status={renaperCheck?.status}
          createdAt={renaperCheck?.createdAt}
          updatedAt={renaperCheck?.updatedAt}
        />
        <Typography variant="h4" sx={{ fontSize: '1rem', marginTop: '1rem', color: 'red' }}>
          Error en los datos ingresados.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1rem' }}>
          {details?.mensaje || 'Error desconocido en la consulta.'}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className="detail-group" sx={{ padding: '1.5rem' }}>
      <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1rem' }}>
        {title || 'Renaper'}
      </Typography>

      <CheckDetailTitle
        email={renaperCheck?.email}
        status={renaperCheck?.status}
        createdAt={renaperCheck?.createdAt}
        updatedAt={renaperCheck?.updatedAt}
      />

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Información del Documento
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>ID Trámite Principal:</strong> {details?.id_tramite_principal || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>ID Tarjeta Reimpresa:</strong> {details?.id_tramite_tarjeta_reimpresa || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Ejemplar:</strong> {details?.ejemplar || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Vencimiento:</strong> {details?.vencimiento || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Emisión:</strong> {details?.emision || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>CUIL:</strong> {details?.cuil || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Datos Personales
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Nombre:</strong> {details?.nombres || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Apellido:</strong> {details?.apellido || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Fecha de Nacimiento:</strong> {details?.fecha_nacimiento || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Nacionalidad:</strong> {details?.nacionalidad || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Dirección
      </Typography>
      <Grid container spacing={1.5} sx={{ marginTop: '0.5rem' }}>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Calle:</strong> {details?.calle || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Número:</strong> {details?.numero || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Ciudad:</strong> {details?.ciudad || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Provincia:</strong> {details?.provincia || '---'}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>País:</strong> {details?.pais || '---'}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h4" sx={{ fontSize: '1.5rem', marginTop: '1.5rem', fontWeight: 'bold' }}>
        Mensaje del Renaper
      </Typography>
      <Typography variant="body1" sx={{ marginTop: '0.5rem' }}>
        {details?.mensaje || '---'}
      </Typography>

      <Divider sx={{ margin: '1rem 0' }} />
    </Box>
  )
}

export default CheckRenaper
 */
